import { EMAIL_POSTAL_CODE_LOGIN_INITIATE } from '@src/app/login/weak/emailpostalcode/actions';
import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { actionCreators } from '@src/app/login/weak/actions';
import { AccountLookupTypes } from '@src/app/_global/domain/AccountLookupTypes';
import { WsgRequest } from '@src/app/_global/domain/WsgRequest';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { getLookupMagCode } from '@src/app/login/loginUtils';

export const emailPostalCodeLoginInitiate = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(EMAIL_POSTAL_CODE_LOGIN_INITIATE),
    mergeMap(({ payload: { email, postalCode, productExcludes } }) => {
      const clientConfig = state$.value.clientConfig.clientConfig;
      const adminConfig = state$.value.adminConfig.adminConfig;
      const lookupMagCode = getLookupMagCode(adminConfig, clientConfig);

      const wsgPayload: WsgRequest = {
        magCode: lookupMagCode,
        globalCode: clientConfig.globalCode,
        filterType: AccountLookupTypes.emailPostalCode,
        payload: {
          email: email as string,
          postalCode: postalCode as string,
          productExcludes: productExcludes.toString(),
        },
      };
      const credentials = state$.value.auth.omsAuth.credentials;
      let observable;
      if (credentials && credentials.Logins) {
        wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
        observable = of(
          actionCreators.authIamKeysSuccess(credentials, wsgPayload),
        );
      } else {
        observable = of(actionCreators.unauthGetIamKeys(wsgPayload));
      }
      return observable;
    }),
  );
